import ajax from "@/lib/ajax";

/**
 * 读取住院汇总表
 * @param payload 查询条件
 */
export async function GetHospitalizationSummaryList(payload: string) {
    let res = await ajax.get(`/api/services/app/PDHospitalizationSummary/GetHospitalizationSummaryList?selectTime=` + payload );
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdQualityControlManage/pdHospitalizationSummary/index.ts